import AnalyticsGateway from '../lib/AnalyticsGateway';
import {truncatedFilename} from './uploadPdf';

export default function sendEditTitleAnalyticsEvent(section, title, label) {
  return (dispatch, getState) => {
    const eventName = label || 'Section Title';
    AnalyticsGateway.sendEvent({
      eventName: `Edit ${eventName}`,
      properties: [
        {label: 'Page', value: 'Customise'},
        {label: 'Property ID', value: getState().propertyDetail.propertyId},
        {label: 'Report Type', value: AnalyticsGateway.reportDescription(getState().reportType.value)},
        {label: 'Section Type', value: section.key === 'CUSTOM' ? 'Custom PDF' : 'Default Section'},
        {label: 'Section Name', value: section.key === 'CUSTOM' ? truncatedFilename(section.filename) : section.uiLabel},
        {label: eventName, value: title},
      ]
    });
  };
}